/**
 * <RequireAdmin> route wrapper.
 * Renders children only if the authenticated user has role === 'admin'.
 * Otherwise redirects to /login (if anonymous) or /dashboard (if non-admin).
 */
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthStore } from "../state/authStore";

export const RequireAdmin = ({ children }) => {
    const { user, isLoading, refresh } = useAuthStore();
    const [checked, setChecked] = useState(!isLoading && user !== undefined);
    const location = useLocation();

    useEffect(() => {
        if (!isLoading) { setChecked(true); return; }
        refresh().finally(() => setChecked(true));
    }, [isLoading, refresh]);

    if (!checked) {
        return (
            <div className="min-h-screen bg-canvas text-text-muted flex items-center justify-center gap-2 text-[13px]">
                <Loader2 className="w-4 h-4 animate-spin text-accent-cyan" /> Checking permissions…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
};

export default RequireAdmin;
